import React, { useState } from 'react'
import {
  BodyText,
  IconButton,
  V2QuestionSmIcon,
  Sheet,
  Button,
} from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'

const ToolTipDiv = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '48px',
})

const SheetTooltip = ({ title, description, linkText, linkHref }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <IconButton
        buttonType="tertiary"
        svgIconComponent={V2QuestionSmIcon}
        size="sm"
        onClick={() => setOpen(true)}
        style={{ color: '#142c8e' }}
      >
        {title}
      </IconButton>
      <Sheet
        className="tooltip-sheet"
        id="tooltip-sheet"
        title={title}
        hideTitle={false}
        isOpen={open}
        onClose={() => setOpen(false)}
      >
        <BodyText style={{ marginTop: '24px' }}>{description}</BodyText>
        <ToolTipDiv>
          <Button
            as="a"
            href={linkHref}
            target="_blank"
            role="button"
            secondary
          >
            {linkText}
          </Button>
        </ToolTipDiv>
      </Sheet>
    </>
  )
}

SheetTooltip.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  linkText: PropTypes.string,
  linkHref: PropTypes.string,
}

export default SheetTooltip
